<template>
      <v-data-table :headers="headers1" :items="ensayo.clave_set" sort-by="calories">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Listado de claves</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="![1,2].some(r => usuario.groups.includes(r))"
                  color="primary"
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                ><v-icon dark left>mdi-plus</v-icon>Nueva clave</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">Nueva clave</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="editedItem.imagen"
                          :items="categorias"
                          label="Imagen"
                        >
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="editedItem.wall"
                          :items="items"
                          label="Pared"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.posx" label="Posición X (m)"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.posy" label="Posición Y (m)"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.height" label="Altura (m)"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.width" label="Ancho (m)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.order="{ item }">
          {{item.order}}
        </template>
        <template v-slot:item.nombre="{ item }">
          <span v-if="item.isEditing===false">{{item.nombre}}</span>
          <v-select
            v-else
            v-model="item.imagen.id"
            :items="categorias"
            class="pa-0 medium-tf"
            hide-details 
            single-line
            dense
          ></v-select>
        </template>
        <template v-slot:item.pared="{ item }">
          <span v-if="item.isEditing===false">{{item.pared}}</span>
          <v-select
            v-else
            v-model="item.pared"
            :items="items"
            class="pa-0 short-tf"
            hide-details 
            single-line
            dense
          ></v-select>
        </template>
        <template v-slot:item.posicionX="{ item }">
          <span v-if="item.isEditing===false">{{item.posicionX}}</span>
          <v-text-field v-else class="pa-0 little-tf" v-model="item.posicionX" hide-details single-line dense></v-text-field>
        </template>
        <template v-slot:item.posicionY="{ item }">
          <span v-if="item.isEditing===false">{{item.posicionY}}</span>
          <v-text-field v-else class="pa-0 little-tf" v-model="item.posicionY" hide-details single-line dense></v-text-field>
        </template>
        <template v-slot:item.height="{ item }">
          <span v-if="item.isEditing===false">{{item.height}}</span>
          <v-text-field v-else class="pa-0 little-tf" v-model="item.height" hide-details single-line dense></v-text-field>
        </template>
        <template v-slot:item.width="{ item }">
          <span v-if="item.isEditing===false">{{item.width}}</span>
          <v-text-field v-else class="pa-0 little-tf" v-model="item.width" hide-details single-line dense></v-text-field>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-container v-if="item.isEditing===false">
            <v-icon :disabled="![1,2].some(r => usuario.groups.includes(r))" small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon :disabled="![1,2].some(r => usuario.groups.includes(r))" small class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
          </v-container>
          <v-container v-else>
            <v-icon small class="mr-2" @click="update(item)">mdi-check</v-icon>
            <v-icon small class="mr-2" @click="cancel(item)">mdi-close</v-icon>
          </v-container>
        </template>
        <template v-slot:no-data>
          No hay datos
        </template>
        </v-data-table>

</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      claves: ['gato', 'mapache', 'mono', 'pajaro', 'pato', 'perro', 'pez', 'pollo'],
      items: [1,2,3,4],
      headers1: [
        { text: '#', value: 'order' , sortable: true},
        { text: 'Clave', value: 'nombre', sortable: true },
        { text: 'Pared', value: 'pared' },
        { text: 'PosX', value: 'posicionX', sortable: false },
        { text: 'PosY', value: 'posicionY', sortable: false },
        { text: 'Altura', value: 'height', sortable: false },
        { text: 'Ancho', value: 'width', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      desserts1: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        wall: undefined,
        posx: undefined,
        posy: undefined,
        height: undefined,
        width: undefined
      },
      defaultItem: {
        name: '',
        wall: undefined,
        posx: undefined,
        posy: undefined,
        height: undefined,
        width: undefined
      },
      selected: []
    }),

    computed: {
      ensayo() {
        return this.$store.state.ensayo
      },
      categorias() {
        let items = [];
        let categorias = this.$store.state.categorias;
        categorias.forEach(item => {
          items.push({
            divider: true
          });
          item.header = item.name;
          items.push(item);
          item.children.forEach(obj => {
            obj.value = obj.id;
            obj.text = obj.name;
            items.push(obj);
          });
        });
        return items;
      },
      usuario() {
        return this.$store.state.user;
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    methods: {
      initialize () {
        this.desserts = [
          {
            id: 1,
            name: 'Frozen Yogurt',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
          },
          {
            id: 2,
            name: 'Ice cream sandwich',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
          },
        ]
      },

      editItem (item) {
        var editedIndex = this.ensayo.clave_set.indexOf(item)
        item = Object.assign({}, item)
        item.isEditing = true;
        item.preNombre = item.nombre;
        item.prePared = item.pared;
        item.prePosX = item.posicionX;
        item.prePosY = item.posicionY;
        item.preHeight = item.height;
        item.preWidth = item.width;
        item.preValue = item.value;
        Object.assign(this.ensayo.clave_set[editedIndex], item)
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      deleteItem (item) {
        confirm('Are you sure you want to delete this item?') && this.$store.dispatch('deleteClave', {
          'id': this.ensayo.id,
          'item': item
        });
      },

      save () {
        console.log(this.editedItem);
        this.$store.dispatch('createClave', {
          'id': this.ensayo.id,
          'item': this.editedItem
        });
        this.close()
      },

      update (item) {
        item.isEditing = false;
        var editedIndex = this.ensayo.clave_set.indexOf(item);
        Object.assign(this.ensayo.clave_set[editedIndex], item);
        this.$store.dispatch('editClave', {
          'id': this.ensayo.id, 
          'item': item
        });
      },

      cancel (item) {
        item.isEditing = false;
        item.nombre = item.preNombre;
        item.pared = item.prePared;
        item.posicionX = item.prePosX;
        item.posicionY = item.prePosY;
        item.height = item.preHeight;
        item.width = item.preWidth;
        var editedIndex = this.ensayo.clave_set.indexOf(item)
        Object.assign(this.ensayo.clave_set[editedIndex], item)
      }
    },
  }
</script>

<style scoped>
  .short-tf {
    width: 50px;
  }
  .medium-tf {
    width: 70px;
  }
  .little-tf {
    width: 30px;
  }
</style>
